module.exports = __webpack_public_path__ + "media/images/themes/dark/logo-animated-788eb44d180928cf52dbd6133f1f302e.gif";